import { Pagination } from 'flowbite-react';
import React, { useState } from "react";
import PastCollaborations from "../components/past-collaboration";
import SearchBar from "../components/search-bar";
import SubNav from '../components/subNav';
import { baseUrl } from '../config';



const Influencers = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(2);
  const influencers = [
    { name: "John Doe", location: "New York, USA", followers: 150000 },
    { name: "Jane Smith", location: "London, UK", followers: 200000 },
    { name: "Alex Green", location: "Los Angeles, USA", followers: 50000 },
    { name: "Emma Brown", location: "Sydney, Australia", followers: 120000 },
  ];

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleSortChange = (option) => {
    setSortOption(option);
  };

  const filteredInfluencers = influencers
    .filter((influencer) =>
      influencer.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => {
      if (sortOption === "Followers Low to High") {
        return a.followers - b.followers;
      } else if (sortOption === "Location") {
        return a.location.localeCompare(b.location);
      }
      return 0;
    });

  const indexOfLastInfluencer = currentPage * itemsPerPage;
  const indexOfFirstInfluencer = indexOfLastInfluencer - itemsPerPage;
  const currentInfluencers = filteredInfluencers.slice(indexOfFirstInfluencer, indexOfLastInfluencer);
  const totalPages = Math.ceil(filteredInfluencers.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <SubNav />
      <div className="min-h-screen bg-white text-gray-900">
        <header className="bg-blue-600 p-6 text-white text-center">
          <h1 className="text-3xl font-bold">Influencers</h1>
        </header>

        <main className="container mx-auto p-6">
          <SearchBar onSearch={handleSearch} onSortChange={handleSortChange} />

          <div className="mt-6 overflow-x-auto">
            <table className="min-w-full bg-white border-collapse border border-gray-300">
              <thead>
                <tr>
                  <th className="py-3 px-4 bg-gray-200 text-left text-gray-600 font-bold uppercase text-sm border-b border-gray-300">
                    Name
                  </th>
                  <th className="py-3 px-4 bg-gray-200 text-left text-gray-600 font-bold uppercase text-sm border-b border-gray-300">
                    Location
                  </th>
                  <th className="py-3 px-4 bg-gray-200 text-left text-gray-600 font-bold uppercase text-sm border-b border-gray-300">
                    Followers
                  </th>
                  <th className="py-3 px-4 bg-gray-200 border-b border-gray-300"></th>
                </tr>
              </thead>
              <tbody>
                {currentInfluencers.map((influencer, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="py-4 px-4 border-b border-gray-300 flex items-center">
                      <div className="rounded-full bg-gray-300 text-center text-white w-10 h-10 flex items-center justify-center mx-2">
                        {influencer.name.charAt(0).toUpperCase()}
                      </div>
                      <a href='/portfolio' className="text-blue-600">{influencer.name}</a>
                    </td>
                    <td className="py-4 px-4 border-b border-gray-300">{influencer.location}</td>
                    <td className="py-4 px-4 border-b border-gray-300">
                      {influencer.followers.toLocaleString()}
                    </td>
                    <td className="py-4 px-4 border-b border-gray-300">
                      <button className="bg-yellow-400 text-white px-4 py-2 rounded-lg hover:bg-blue-600">
                        Connect
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center mt-4">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>

          <div className="mt-12">
            <PastCollaborations />
          </div>
        </main>
      </div>
    </>
  );
};

export default Influencers;

